/**
 * 検索送信時に検索結果ページ（/search）へ遷移する。
 * q と options[prefix] のみ付与し、他ページのクエリは引き継がない。
 */
(function () {
  function getSearchBaseUrl(form) {
    const action = form?.getAttribute('action');
    if (action) return action;
    if (window.routes?.search_url) return window.routes.search_url;
    return '/search';
  }

  function navigateToSearchResults(form) {
    const input = form?.querySelector('input[name="q"]');
    const q = input?.value?.trim();
    if (!q) return false;

    let url;
    try {
      url = new URL(getSearchBaseUrl(form), window.location.origin);
    } catch {
      url = new URL('/search', window.location.origin);
    }

    url.search = '';
    url.searchParams.set('q', q);

    const prefixInput = form.querySelector('input[name="options[prefix]"]');
    url.searchParams.set('options[prefix]', prefixInput?.value || 'last');

    window.location.assign(url.pathname + url.search);
    return true;
  }

  window.navigateToSearchResults = navigateToSearchResults;

  function isDirectSearchForm(form) {
    if (!(form instanceof HTMLFormElement)) return false;
    if (form.closest('predictive-search')) return false;
    return (
      form.matches('.header-inline-search__form, .menu-drawer-search') ||
      (form.matches('.search') && form.closest('main-search'))
    );
  }

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!isDirectSearchForm(form)) return;
      event.preventDefault();
      navigateToSearchResults(form);
    },
    true
  );
})();
